import Agent from './resource';
import errorTransformer from '@/api/shared/transformers/errorTransformer';

let currentAgentConfigInFlightRequest = null;

function extractCurrentAgentConfig(response) {
  return response?.body?.data || response?.body || response?.data || {};
}

function getCurrentAgentConfigData({ force = false } = {}) {
  if (!force && currentAgentConfigInFlightRequest) {
    return currentAgentConfigInFlightRequest;
  }

  const request = Agent.getCurrentAgentConfig()
    .then(extractCurrentAgentConfig)
    .catch(errorTransformer)
    .finally(() => {
      if (currentAgentConfigInFlightRequest === request) {
        currentAgentConfigInFlightRequest = null;
      }
    });

  currentAgentConfigInFlightRequest = request;

  return request;
}

function getSupportUnreadTicketConfig(options = {}) {
  return getCurrentAgentConfigData(options).then(configData => {
    const supportData = configData.support || {};
    const dev = Number(supportData?.dev?.unread_tickets || 0);
    const userByPackage = Array.isArray(supportData.user)
      ? supportData.user.reduce((acc, item) => {
          if (item?.package_name) {
            acc[item.package_name] = Number(item.unread_tickets || 0);
          }

          return acc;
        }, {})
      : {};

    return {
      dev,
      userByPackage,
    };
  });
}

function getCurrentAgentPreferences() {
  return Agent.getCurrentAgentPreferences()
    .then(({ body: { data } }) => data)
    .catch(errorTransformer);
}

function setCurrentAgentPreferences({ name: slug, app, value }) {
  return Agent.setCurrentAgentPreferences(
    { slug },
    {
      apps: [
        {
          name: app,
          value,
        },
      ],
    },
  )
    .then(({ body }) => body)
    .catch(errorTransformer);
}

export default {
  ...Agent,
  getCurrentAgentConfigData,
  getCurrentAgentPreferences,
  getSupportUnreadTicketConfig,
  setCurrentAgentPreferences,
};
